import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const rootElement = document.getElementById('root')
const queryClient = new QueryClient();

if (rootElement) {
  const root = createRoot(rootElement) // Criar o root
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  )
} else {
  console.error('Elemento root não encontrado')
}
